// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { requisitionsProductListLineStyles } from "@insite/content-library/Widgets/Requisitions/RequisitionsProductListLine";
import cartLineSharedStyles from "@tps/App/SharedStyles/CartLineSharedStyles";
import { css } from "styled-components";

requisitionsProductListLineStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};
requisitionsProductListLineStyles.productImageStyles = {
    ...cartLineSharedStyles.productImage,
};
requisitionsProductListLineStyles.productPriceStyles = {
    ...cartLineSharedStyles.productPrice,
};
requisitionsProductListLineStyles.subtotalHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};
requisitionsProductListLineStyles.productPartNumbersStyles = {
    ...cartLineSharedStyles.productPartNumbers,
};

requisitionsProductListLineStyles.requisitionLinesAccordion = {
    mergeCss: true,
    css: css`
        margin-top: 10px;
    `,
};
